import { createEmojiIcon } from '../EmojiIcon';

export const CheckCircleIcon = createEmojiIcon('✅');
export const ErrorIcon = createEmojiIcon('❌');
export const WarningIcon = createEmojiIcon('⚠️');
export const InfoIcon = createEmojiIcon('ℹ️');
